import {useContext} from 'react';

import ReportViewsContext from '../../contexts/ReportViewsContext';

const useReportViews = () => {
  return useContext(ReportViewsContext);
};

export default useReportViews;
